import React, { useEffect, useState } from 'react';
import { FieldValues, Path } from 'react-hook-form';
import RadioList, { FilterListItem } from '../RadioList';
import { cameraService } from '../../../services/central-api/cameras';

function CameraOriginList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    const [items, setItems] = useState<FilterListItem<string>[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getThirdPartyCameraOrigins() {
        try {
            const origins = await cameraService.getThirdPartyCameraOrigins('all');
            setItems(origins.map(origin => ({ label: origin.origin, value: origin.origin })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getThirdPartyCameraOrigins();
    }, []);

    return <RadioList name={name} items={items} clearValue={null} isLoading={isLoading} />;
}

CameraOriginList.getCount = RadioList.getCount;

export default CameraOriginList;
